import moment from 'moment'
import 'moment/locale/es'

moment.defaultFormat = 'YYYY-MM-DD'
moment.locale('es')
